import global from './global/global'
import forms from './forms/forms'

export const globalContext = global
export const formsContext = forms
